export const backends = [
  {
    label: 'localhost',
    value: 'http://localhost:8999/api/internal/ops',
    env: 'dev',
    disabled: false,
    countryCode: 'fi',
    timezone: 'Europe/Amsterdam',
    defaultWotts: {
      b2c: [11299, 10391, 10198],
    },
    hostname: 'localhost',
  },
  {
    label: 'Finland Staging',
    value: 'https://ops.stag.yeply.fi/api/internal/ops',
    env: 'staging',
    disabled: false,
    countryCode: 'fi',
    timezone: 'Europe/Helsinki',
    defaultWotts: {
      b2c: [19],
    },
    hostname: 'ops.stag.yeply.fi',
  },
  {
    label: 'Finland',
    value: 'https://ops.yeply.fi/api/internal/ops',
    env: 'prod',
    disabled: false,
    countryCode: 'fi',
    timezone: 'Europe/Helsinki',
    defaultWotts: {
      b2c: [357, 358, 15],
    },
    hostname: 'ops.yeply.fi',
  },
  {
    label: 'Netherlands',
    value: 'https://ops.yeply.nl/api/internal/ops',
    env: 'prod',
    disabled: false,
    countryCode: 'nl',
    timezone: 'Europe/Amsterdam',
    virtualLocations: [2043, 3736, 3805],
    hostname: 'ops.yeply.nl',
  },
  {
    label: 'Germany',
    value: 'https://ops.yeply.de/api/internal/ops',
    env: 'prod',
    disabled: false,
    countryCode: 'de',
    timezone: 'Europe/Berlin',
    hostname: 'ops.yeply.de',
  },
]
